import { render, staticRenderFns } from "./StockNameTemplate.vue?vue&type=template&id=ca414ed0&scoped=true&"
import script from "./StockNameTemplate.vue?vue&type=script&lang=js&"
export * from "./StockNameTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca414ed0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca414ed0')) {
      api.createRecord('ca414ed0', component.options)
    } else {
      api.reload('ca414ed0', component.options)
    }
    module.hot.accept("./StockNameTemplate.vue?vue&type=template&id=ca414ed0&scoped=true&", function () {
      api.rerender('ca414ed0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/StockNameTemplate.vue"
export default component.exports